import React from "react";
import styled from "@emotion/styled";

const Loader = ({ backgroundColor }) => {
  const LoaderContainer = styled.div`
    font-size: 2vw;
    width: 2vw;
    height: 2vw;
    border-radius: 50%;
    background: #fff;
    background: -moz-linear-gradient(left, #37a46e 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #37a46e 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #37a46e 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #37a46e 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #37a46e 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    left: 2px;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);

    &:before {
      width: 50%;
      height: 50%;
      background: #37a46e;
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
      content: "";
    }
    &:after {
      background: ${backgroundColor};
      width: 75%;
      height: 75%;
      border-radius: 50%;
      content: "";
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  `;

  return <LoaderContainer />;
};

export default Loader;
